// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__DYYtO","NavigationButtons":"NavigationItems_NavigationButtons__2kF0G","LanguageButtons":"NavigationItems_LanguageButtons__1qKTV"};